import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.array.reduce.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.filter.js";
import "core-js/modules/es.iterator.map.js";
import "core-js/modules/es.iterator.reduce.js";
import "core-js/modules/es.json.parse.js";
import "core-js/modules/es.set.difference.v2.js";
import "core-js/modules/es.set.intersection.v2.js";
import "core-js/modules/es.set.is-disjoint-from.v2.js";
import "core-js/modules/es.set.is-subset-of.v2.js";
import "core-js/modules/es.set.is-superset-of.v2.js";
import "core-js/modules/es.set.symmetric-difference.v2.js";
import "core-js/modules/es.set.union.v2.js";
import SyncAccountsTab from "./components/SyncAccountsTab.vue";
import SyncAlertsTab from "./components/SyncAlertsTab.vue";
import SyncConfigTab from "./components/SyncConfigTab.vue";
import SyncLogsTab from "./components/SyncLogsTab.vue";
import SyncOverviewTab from "./components/SyncOverviewTab.vue";
import { getDownstreamOverview, getDownstreamSyncConfigs } from "@/service/sync-manage";
import { systemName } from "./components/sync-utils";
export default {
  name: "sync-manage",
  components: {
    SyncAccountsTab,
    SyncAlertsTab,
    SyncConfigTab,
    SyncLogsTab,
    SyncOverviewTab
  },
  data() {
    return {
      activeTab: "overview",
      configs: [],
      overview: {},
      activeSystem: "",
      alertTabCount: null
    };
  },
  computed: {
    // 系统菜单进入时没有应用上下文，默认按 iWork 同步应用查询。
    appId() {
      return "USER_SYNC_MANAGEMENT";
    },
    // 优先使用路由单位代码，其次兼容当前登录单位和本地切换单位缓存。
    unitCode() {
      const localUnit = this.getLocalUnit();
      return this.$route.query.unitCode || this.$store.state.user.userInfo.unitCode || localUnit.code || "";
    },
    // 下游系统必须来自配置/总览接口，避免前端写死可操作系统范围。
    downstreamOptions() {
      const systems = [...this.configs.map(item => item.downstreamSystem), ...(this.overview.downstreams || []).map(item => item.downstreamSystem)].filter(Boolean);
      return [...new Set(systems)].map(system => ({
        label: systemName(system),
        value: system
      }));
    },
    alertTotalCount() {
      // 告警页已加载后优先使用列表接口真实总数，处理成功后的角标才能立即跟随列表刷新。
      if (Number.isFinite(this.alertTabCount)) {
        return this.alertTabCount;
      }
      const rootCauseTotal = this.rootCauseAlertTotal();
      if (rootCauseTotal !== null) return rootCauseTotal;
      const downstreams = this.overview.downstreams || [];
      const explicitCount = this.firstNumber(this.overview, ["alertCount", "pendingAlertCount", "unresolvedAlertCount"]);
      if (explicitCount !== null) return explicitCount;
      const downstreamAlertCount = downstreams.map(item => this.firstNumber(item, ["alertCount", "pendingAlertCount", "unresolvedAlertCount"])).filter(count => count !== null);
      if (downstreamAlertCount.length) {
        return downstreamAlertCount.reduce((total, count) => total + count, 0);
      }
      return downstreams.reduce((total, item) => {
        return total + (item.failedCount || 0) + (item.unackedCount || 0);
      }, 0);
    },
    // Tab label 用函数渲染，保证告警数字与图中红色徽标保持一致。
    alertTabLabel() {
      const label = $t("b7kwke4", "告警处理");
      const count = this.alertTotalCount;
      return h => h("span", {
        class: "sync-tab-label"
      }, [label, count ? h("span", {
        class: "sync-tab-badge"
      }, String(count)) : null]);
    }
  },
  async mounted() {
    await this.reloadConfigContext();
  },
  methods: {
    getLocalUnit() {
      try {
        return JSON.parse(localStorage.getItem("unit") || "{}");
      } catch (error) {
        return {};
      }
    },
    firstNumber(source, fields) {
      for (const field of fields) {
        if (source[field] !== undefined && source[field] !== null) {
          const numberValue = Number(source[field]);
          return Number.isFinite(numberValue) ? numberValue : 0;
        }
      }
      return null;
    },
    // 未加载告警列表前使用总览根因字段，加载后由告警列表真实总数覆盖。
    rootCauseAlertTotal() {
      const unitCodeNotMatchedCount = this.sumRootCauseField("unitCodeNotMatchedCount");
      const multipleMatchedCount = this.sumRootCauseField("multipleMatchedCount");
      if (unitCodeNotMatchedCount === null && multipleMatchedCount === null) {
        return null;
      }
      return (unitCodeNotMatchedCount || 0) + (multipleMatchedCount || 0);
    },
    // 根因字段可能在总览顶层，也可能按 downstreams 返回，统一聚合后给角标使用。
    sumRootCauseField(field) {
      const overviewCount = this.firstNumber(this.overview, [field]);
      if (overviewCount !== null) return overviewCount;
      const downstreams = this.overview.downstreams || [];
      const matchedItems = downstreams.filter(item => Object.prototype.hasOwnProperty.call(item, field));
      if (!matchedItems.length) return null;
      return matchedItems.reduce((total, item) => total + (this.firstNumber(item, [field]) || 0), 0);
    },
    contextPayload(extra = {}) {
      return {
        appId: this.appId,
        unitCode: this.unitCode,
        ...extra
      };
    },
    // 配置和总览共同驱动下游系统筛选项，保存配置后统一刷新这一层上下文。
    async reloadConfigContext() {
      await this.loadConfigs();
      await this.loadOverview();
    },
    async loadConfigs() {
      if (!this.unitCode) return;
      const {
        data: {
          result,
          retVal
        }
      } = await getDownstreamSyncConfigs({
        appId: this.appId,
        unitCode: this.unitCode
      });
      if (result === 0) {
        this.configs = retVal || [];
        if (!this.activeSystem && this.configs.length) {
          this.activeSystem = this.configs[0].downstreamSystem;
        }
      }
    },
    // 总览只查询状态数据，不触发重推、补偿或候选匹配等副作用接口。
    async loadOverview() {
      if (!this.unitCode) return;
      const {
        data: {
          result,
          retVal
        }
      } = await getDownstreamOverview(this.contextPayload());
      if (result === 0) {
        this.overview = retVal || {};
      }
    },
    // 从其他页签回到同步配置时固定回到 UC；若未来没有 UC，则回退到首个可展示系统。
    resetConfigActiveSystem() {
      const preferredSystems = ["UC", "IHOTEL", "ICATER"];
      const availableSystems = [...preferredSystems, ...this.configs.map(item => item.downstreamSystem), ...(this.overview.downstreams || []).map(item => item.downstreamSystem)].filter(Boolean);
      const systemSet = [...new Set(availableSystems)];
      this.activeSystem = systemSet.includes("UC") ? "UC" : systemSet[0] || "UC";
    },
    async onTabChange(name) {
      if (name === "overview") await this.loadOverview();
      if (name === "overview") {
        await this.$nextTick();
        const overviewTab = this.$refs.overviewTab;
        if (overviewTab && typeof overviewTab.syncOverviewConnectionStatuses === "function") {
          // 每次切回状态总览时仅按当前 3 个业务系统各探活一次，避免 watch 与页签切换重复叠加。
          overviewTab.syncOverviewConnectionStatuses(true);
        }
      }
      if (name === "config") {
        this.resetConfigActiveSystem();
        await this.reloadConfigContext();
        await this.$nextTick();
        const configTab = this.$refs.configTab;
        if (configTab && typeof configTab.syncConnectionStatus === "function") {
          // 每次切入同步配置页都按当前默认系统重新探活，避免复用隐藏页签的旧结果。
          configTab.syncConnectionStatus({
            force: true
          });
        }
      }
      if (["alerts", "logs", "accounts"].includes(name)) {
        const tab = this.$refs[`${name}Tab`];
        if (tab && typeof tab.resetFilters === "function") {
          // 仅在页签切换回当前页面时重置筛选，页内主动搜索/筛选不受影响。
          tab.resetFilters();
        }
        await this.refreshTab(name, true);
      }
    },
    // 子 Tab 内部管理各自筛选和表格，父级只负责按页签派发刷新。
    refreshTab(name, reset = false) {
      return new Promise(resolve => {
        this.$nextTick(() => {
          const tab = this.$refs[`${name}Tab`];
          if (tab && tab.refresh) tab.refresh(reset);
          resolve();
        });
      });
    },
    // 总览告警入口只切换到告警页签并刷新列表，不直接处理任何告警数据。
    async showAlertsTab() {
      this.activeTab = "alerts";
      await this.refreshTab("alerts", true);
    },
    // 告警角标使用告警列表接口返回的实际总数，切换 Tab 后也保持同一来源。
    updateAlertTabCount(count) {
      const numberValue = Number(count);
      this.alertTabCount = Number.isFinite(numberValue) ? numberValue : null;
    },
    showOperationResult(data) {
      if ((data === null || data === void 0 ? void 0 : data.result) === 0) {
        var _data$retVal;
        this.$Message.success(((_data$retVal = data.retVal) === null || _data$retVal === void 0 ? void 0 : _data$retVal.message) || $t("d1spvi4", "操作成功"));
      } else {
        var _data$retVal2;
        this.$Message.error((data === null || data === void 0 || (_data$retVal2 = data.retVal) === null || _data$retVal2 === void 0 ? void 0 : _data$retVal2.message) || (data === null || data === void 0 ? void 0 : data.msg) || $t("d1rj434", "操作失败"));
      }
    }
  }
};